import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { Dialog } from 'react-toolbox';
import styles from 'styles/input.scss';
import ConfirmDialog from 'components/ConfirmDialog';
import TextArea from 'components/TextArea';
import S from 'modal.scss';
import { editPhaseAppointment } from 'actionCreators/appointments';
import { getPhaseErrors } from '../../../../../../../../reducers';

const DEFAULT_STATE = { note: '', showConfirm: false, errors: {} };
const SS_DATA = { source: 'calendar', ignoredWarnings: [] };

class ConvertAppointmentModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = DEFAULT_STATE;
  }

  handleNoteChange = e => this.setState({ note: e.target.value });

  handleSubmit = () => {
    const errors = {};
    if (this.state.note.trim() === '') errors.reason = 'Can\'t be blank.';
    this.setState({ errors, showConfirm: !errors.note });
  }

  handleClose = () => {
    this.setState(DEFAULT_STATE);
    this.props.onClose();
  }

  handleConfirmSubmit = () => {
    const { phaseId, appointment: { id = null, kind = '' } } = this.props;
    const params = { note: this.state.note };
    if (kind === 'installation_hold') params.kind = 'installation';
    else if (kind === 'workorder_hold') params.kind = 'repair';
    else if (kind === 'assessment_hold') params.kind = 'assessment';
    else params.kind = 'delivery';
    this.props.editPhaseAppointment(id, phaseId, params, SS_DATA, {})
      .then(() => this.handleClose());
  }

  handleConfirmClose = () => this.handleClose();

  render = () => {
    const { active, serverErrors } = this.props;
    const { note, showConfirm, errors } = this.state;
    return (<Dialog
      active={active}
      className={S.modal}
      type="fullscreen"
      onEscKeyDown={this.handleClose}
      onOverlayClick={this.handleClose}
    >
      <div className={styles.errored}>
        {Object.keys(serverErrors).length > 0 &&
          <span className={styles.error}>This action could not be completed.</span>}
      </div>
      <IconButton
        icon="close"
        className={S.close}
        onClick={this.handleClose}
        tabIndex={-1}
      />
      <h5 className={S.title}>Confirm Appointment</h5>
      <TextArea
        label="Note *"
        value={note}
        errors={[errors.note]}
        onChange={this.handleNoteChange}
      />
      <Button
        label="Confirm Appointment"
        flat inverse ripple
        className={S.submit}
        onClick={this.handleSubmit}
      />
      <ConfirmDialog
        title="Are you sure you want to confirm this appointment?"
        okLabel="Yes, Confirm the Appointment"
        cancelLabel="No"
        show={showConfirm}
        cancel={this.handleConfirmClose}
        dismiss={this.handleConfirmClose}
        proceed={this.handleConfirmSubmit}
      />
    </Dialog>);
  }
}

ConvertAppointmentModal.propTypes = {
  active: PropTypes.bool.isRequired,
  editPhaseAppointment: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  phaseId: PropTypes.number,
  appointment: PropTypes.object,
  serverErrors: PropTypes.shape({}),
};

ConvertAppointmentModal.defaultProps = { active: false };

export default connect(
  state => ({ serverErrors: getPhaseErrors(state) }),
  { editPhaseAppointment },
)(ConvertAppointmentModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAppointments/components/convertAppointmentModal.jsx